module.exports = __webpack_public_path__ + "images/126_320.jpg";